import { Redirect, Route, Switch } from 'react-router-dom';
import { registerBrowserRoutes } from '@zg-rentals/route-list';
import { AuthCheckWrapper, NotFoundPage, defaultPaths as paths } from '@zg-rentals/rental-manager-env';

import FrontPage from '../components/FrontPage';
import DevPage from '../components/DevPage';
import UserManagementInvitationPage from '../pages/UserManagementInvitationPage';
import UserManagementPage from '../pages/UserManagementPage';
import AddUserPage from '../components/AddUserPage';
import ManageListingPermissionsPage from '../pages/ManageListingPermissionPage/ManageListingPermissionPage';

export const manifest = {
  home: '/',
  dev: '/dev',
  userManagement: paths.userManagementPage,
  acceptInvitePage: paths.userManagementPage + '/invitation',
  usersPage: paths.userManagementPage + '/' + paths.userManagementUsers,
  pendingPage: paths.userManagementPage + '/' + paths.userManagementPending,
  activityPage: paths.userManagementPage + '/' + paths.userManagementActivity,
  unrecognizedPage: paths.userManagementPage + '/' + paths.userManagementUnrecognizedUsers,
  applicationsPage: paths.userManagementPage + '/' + paths.userManagementApplicationPermissions,
  addUserPage: paths.userManagementPage + '/' + paths.userManagementAddUser,
  editUserPage: paths.userManagementPage + '/' + paths.userManagementEditUser,
  manageListingPermissionPage: paths.userManagementPage + '/listing-permissions/:listingAlias',
};

const ALLOW_PARAMS_REGEX = '([?].*)?([&].*)?';

registerBrowserRoutes(manifest);

export function getRoutes() {
  return (
    <Switch>
      <Route exact component={FrontPage} path={manifest.home} />
      <Route exact component={DevPage} path={manifest.dev} />
      <Route exact path={manifest.usersPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.pendingPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.activityPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.unrecognizedPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.applicationsPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.addUserPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <AddUserPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.editUserPage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <AddUserPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.acceptInvitePage + ALLOW_PARAMS_REGEX}>
        <AuthCheckWrapper>
          <UserManagementInvitationPage />
        </AuthCheckWrapper>
      </Route>
      <Route exact path={manifest.manageListingPermissionPage}>
        <AuthCheckWrapper>
          <ManageListingPermissionsPage />
        </AuthCheckWrapper>
      </Route>
      <Route render={() => <Redirect to={manifest.usersPage} />} exact={true} path={manifest.userManagement} />
      <Route path="*" exact={true} component={NotFoundPage} />
    </Switch>
  );
}
